import { registerPlugin } from '@capacitor/core'
import type { ShareAPIPlugin } from './definitions'

const ShareAPI = registerPlugin<ShareAPIPlugin>('ShareAPI')

export * from './definitions'
export { ShareAPI }
